import { types } from '../../types/types'

export const initialState = {
    permissions: []
}

export const authPermissionsReducer = (state = {}, action) => {
    switch (action.type) {

        case types.loadPermissions:
            return {
                ...state,
                permissions: action.payload
            }

        case types.clearPermissionsUser:
            return {
                ...state,
                permissions: []
            }

        default:
            return state;
    }
}